import { Link } from "react-router-dom";
import { MapPin, Calendar, Clock, Users, Star, Fish, Anchor } from "lucide-react";

function fmtDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" });
  } catch { return iso; }
}
function fmtTime(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
}

export default function TripCard({ trip, compact = false }) {
  const lowSpots = trip.spots_left <= 1;
  return (
    <Link
      to={`/sortie/${trip.trip_id}`}
      data-testid={`trip-card-${trip.trip_id}`}
      className="group block bg-blanc rounded-2xl border border-brume hover:border-bretagne/40 hover:shadow-matelot transition-all p-5"
    >
      {/* Header row : type + places */}
      <div className="flex items-center justify-between gap-3">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-bretagne">
          <Fish className="w-3.5 h-3.5" /> {trip.type}
        </span>
        <span
          className={`text-xs font-bold px-2.5 py-1 rounded-full ${
            trip.spots_left === 0
              ? "bg-ocean/10 text-ocean/60"
              : lowSpots
              ? "bg-corail/15 text-corail"
              : "bg-turquoise/15 text-turquoise"
          }`}
        >
          {trip.spots_left === 0
            ? "Complet"
            : `${trip.spots_left} place${trip.spots_left > 1 ? "s" : ""}`}
        </span>
      </div>

      {/* Title */}
      <h3 className="mt-2 font-display text-lg md:text-xl font-bold text-ocean leading-snug group-hover:text-corail transition-colors">
        {trip.title}
      </h3>

      {/* Info rows */}
      <div className="mt-3 grid grid-cols-2 gap-y-1.5 gap-x-3 text-sm text-ocean/85">
        <span className="inline-flex items-center gap-1.5">
          <MapPin className="w-4 h-4 text-bretagne shrink-0" /> {trip.port}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Calendar className="w-4 h-4 text-bretagne shrink-0" /> {fmtDate(trip.date)} · {fmtTime(trip.date)}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Clock className="w-4 h-4 text-bretagne shrink-0" /> {trip.duration_hours}h
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Users className="w-4 h-4 text-bretagne shrink-0" /> {trip.level}
        </span>
      </div>

      {/* Footer : participation + CTA */}
      <div className="mt-4 pt-4 border-t border-brume flex items-center justify-between gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-bretagne/80 font-bold">
            Participation aux frais
          </div>
          <div className="font-display text-2xl font-bold text-ocean leading-none mt-0.5">
            {trip.price_per_person}€
            <span className="text-xs text-bretagne/80 font-sans font-semibold"> / pers.</span>
          </div>
        </div>
        <div className="flex flex-col items-end gap-1.5">
          <span className="inline-flex items-center gap-1 text-xs text-ocean/80">
            <Anchor className="w-3.5 h-3.5 text-bretagne" />
            <span className="font-semibold">{trip.captain_name}</span>
            {trip.captain_rating > 0 && (
              <>
                <Star className="w-3 h-3 fill-jaune text-jaune ml-1" />
                <span>{trip.captain_rating.toFixed(1)}</span>
              </>
            )}
          </span>
          <span className="text-xs font-bold text-ocean group-hover:underline">
            Demander ma place →
          </span>
        </div>
      </div>
    </Link>
  );
}
